'use client'
import { TextInput, TextInputMask, TextArea, CheckboxItem, ColorButton, ReplyMessage, TextInputUpperCase } from "@/components/ui";
import { IdCard, AtSign, Lock, Smile, User, Text, SquareCheck, Contact } from "@/assets/icons";
import { useRouter } from "next/navigation";
import { registerUserForm } from "@/app/api";
import { useActionState } from "react";
import Form from "next/form";

export function RegisterUser() {
    const [state, formAction, pending] = useActionState(registerUserForm, {
        values: { hits: 0, code: '', identifier: '', name: '', userName: '', email: '', password: '', observation: '', userType: '' },
        errors: {},
        message: '',
    })

    const router = useRouter();
    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);
    }

    return (
        <div className="border border-ochre_accent rounded-md p-6">

            <Form action={formAction} className="flex flex-col gap-3">

                {/* cpf or cnpj of user */}

                <div className="flex gap-2 items-center">
                    <User className="size-4" />
                    <label htmlFor="identifier">CPF/CNPJ</label>
                </div>
                <TextInputMask name="identifier" id="identifier"
                    minLength={11} maxLength={18} required
                    value={state?.values?.identifier}
                    placeholder="CPF/CNPJ" />
                {state?.errors?.identifier && <p>{state.errors.identifier}</p>}

                {/* code of user */}

                <div className="flex gap-2 items-center">
                    <IdCard className="size-4" />
                    <label htmlFor="code">Código</label>
                </div>
                <TextInput name="code" id="code"
                    minLength={4} maxLength={4} required
                    defaultValue={state?.values?.code}
                    placeholder="Código" />
                {state?.errors?.code && <p>{state.errors.code}</p>}

                {/* username of user */}

                <div className="flex gap-2 items-center">
                    <Contact className="size-4" />
                    <label htmlFor="userName">Empresa</label>
                </div>
                <TextInputUpperCase name="userName" id="userName"
                    required
                    value={state?.values?.userName}
                    placeholder="Empresa" />
                {state?.errors?.userName && <p>{state.errors.userName}</p>}

                {/* name of user */}

                <div className="flex gap-2 items-center">
                    <Smile className="size-4" />
                    <label htmlFor="name">Nome</label>
                </div>
                <TextInput name="name" id="name"
                    required
                    defaultValue={state?.values?.name}
                    placeholder="Nome" />
                {state?.errors?.name && <p>{state.errors.name}</p>}

                {/* email of user */}

                <div className="flex gap-2 items-center">
                    <AtSign className="size-4" />
                    <label htmlFor="email">Email</label>
                </div>
                <TextInput name="email" id="email"
                    required
                    defaultValue={state?.values?.email}
                    placeholder="Email" />
                {state?.errors?.email && <p>{state.errors.email}</p>}

                {/* password of user */}

                <div className="flex gap-2 items-center">
                    <Lock className="size-4" />
                    <div className="flex gap-1 items-baseline">
                        <label htmlFor="password">Senha</label>
                        <p className="text-xs">min. 6 caracteres</p>
                    </div>
                </div>
                <TextInput name="password" id="password"
                    required
                    defaultValue={state?.values?.password}
                    placeholder="Senha" />
                {state?.errors?.password && <p>{state.errors.password}</p>}

                {/* observation of user */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="observation">Observação</label>
                </div>
                <TextArea name="observation" id="observation"
                    defaultValue={state?.values?.observation}
                    placeholder="Observação" />
                {state?.errors?.observation && <p>{state.errors.observation}</p>}

                {/* type of user */}

                <div className="flex gap-2 items-center">
                    <SquareCheck className="size-4" />
                    <label htmlFor="userType">Tipo de usuário</label>
                </div>
                <div className="flex flex-wrap gap-5">
                    <CheckboxItem name="userType" id="userType"
                        value="admin" label="Administrador"
                        defaultChecked={state?.values?.userType === "admin"} />

                    <CheckboxItem name="userType" id="userType"
                        value="client" label="Cliente"
                        defaultChecked={state?.values?.userType === "client"} />


                    <CheckboxItem name="userType" id="userType"
                        value="seller" label="Vendedor"
                        defaultChecked={state?.values?.userType === "seller"} />


                    <CheckboxItem name="userType" id="userType"
                        value={"accountant"} label="Contador"
                        defaultChecked={state?.values?.userType === "accountant"} />
                </div>
                {state?.errors?.userType && <p>{state.errors.userType}</p>}

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending ? 'Cadastrando...' : 'Cadastrar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}